import React, { useMemo } from "react";
import { container_classname } from "./constants";
import Image from "next/image";
import { useRouter } from "next/router";
import { defaultAddonData } from "./PricingSection/constants";

export interface AddonCard {
    addOnName: string;
    description: string;
    price: string;
    pricingPeriod: string;
    url: string;
}

const priceChipTheme = "text-sm font-medium rounded px-2 py-1 w-fit";

const AddOnSection: React.FC = () => {
    const router = useRouter();
    const countryCode = router.query.country;

    const { isDollar } = useMemo(() => {
        const dateAsString = new Date().toString();
        if (countryCode) {
            const indiaRoute = ["in", "ind"].includes(countryCode as string);
            if (indiaRoute) {
                return { isDollar: false };
            } else {
                return { isDollar: true };
            }
        } else {
            const indiaTimeZone = dateAsString.includes("India Standard Time") || new Date().toString().includes("IST");
            if (indiaTimeZone) {
                return { isDollar: false };
            } else {
                return { isDollar: true };
            }
        }
    }, [countryCode]);

    const addonCard = defaultAddonData(isDollar);

    return (
        <section
            style={{
                background: "linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.24%)",
            }}
            className="py-20"
        >
            <div className={`${container_classname} space-y-10`}>
                <h3 className="md:text-5xl text-4xl font-semibold">Add-Ons</h3>
                <div className="grid md:grid-cols-2 gap-5">
                    {addonCard
                        .filter((addon) => !(isDollar && addon.addOnName === "Dedicated account manager"))
                        .map((addon) => (
                            <div className="flex md:flex-row flex-col gap-3 p-5 bg-white rounded-md" key={addon.addOnName}>
                                <Image src={addon.url} width={64} height={64} alt={`add-Ons-${addon.addOnName}`} className="w-16 h-16" />
                                <div className="md:space-y-2 space-y-4">
                                    <div className="flex flex-wrap gap-x-4 items-center">
                                        <h6 className="text-black text-xl font-semibold">{addon.addOnName}</h6>
                                        {addon.price === "free" ? (
                                            <span className={`${priceChipTheme} text-green-900 bg-green-100`}>free</span>
                                        ) : (
                                            <span className={`${priceChipTheme} bg-gray-100`}>
                                                {addon.price}/ {addon.pricingPeriod}
                                            </span>
                                        )}
                                    </div>
                                    <p>{addon.description}</p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </section>
    );
};

export default AddOnSection;
